<ng-container>
  <div style="height: 100vh">
    <iframe [src]="urlSafe" width="100%" height="100%" frameBorder="0" (load)="iframeload()"></iframe>
  </div>
</ng-container>
